import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

//Import all material modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';

//Import Layouts
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';

// Vertical Layout
import { HeaderComponent } from './layouts/full/header/header.component';
import { BrandingComponent } from './layouts/full/sidebar/branding.component';
import { AppNavItemComponent } from './layouts/full/sidebar/nav-item/nav-item.component';
import { SidebarComponent } from './layouts/full/sidebar/sidebar.component';

import { CommonModule } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { AvatarModule } from 'primeng/avatar';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { AuthGuard } from './services/auth-guard.service';
// import { DestinationAccountComponent } from './pages/pipeline/destination-account/destination-account.component';
// import { PipelinesComponent } from './pages/pipeline/pipelines/pipelines.component';
// import { DestinationAccountDetailComponent } from './pages/pipeline/destination-account-detail/destination-account-detail.component';
// import { PipelineDetailComponent } from './pages/pipeline/pipeline-detail/pipeline-detail.component';
// import { PipelineCreateComponent } from './pages/pipeline/pipeline-create/pipeline-create.component';
// import { OrgDashboardComponent } from './pages/orgdashboad/orgdashboad.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './custom/custom-mat-paginator-intl';
import { environment } from './environments/environment';
import { CacheInterceptor } from './interceptors/cache-interceptor';
import { MockHttpInterceptor } from './interceptors/mock-http-interceptor';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api';
import { ToastService } from './services/toast.service';
import { LoadingInterceptor } from './interceptors/loading-interceptor';
import { LoadingComponent } from './component/loading-component';
import { MissingTranslationHandler, TranslateCompiler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpLoaderFactory } from './shared/shared.module';
import { CustomMissingTranslationHandler } from './i18n/custom-missing-translation-handler';
import { EnvironmentTranslateCompiler } from './i18n/environment-translate-compiler';
//import { NgxChartsModule } from '@swimlane/ngx-charts';

import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    BlankComponent,
    SidebarComponent,
    HeaderComponent,
    BrandingComponent,
    AppNavItemComponent,
    LoadingComponent,
    // DestinationAccountComponent,
    // DestinationAccountDetailComponent,
    // PipelinesComponent,
    // PipelineDetailComponent,
    // PipelineCreateComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: EnvironmentTranslateCompiler
      },
      isolate: true,
    }),
    BrowserAnimationsModule,
    //SharedModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TablerIconsModule.pick(TablerIcons),
    MatNativeDateModule,
    TableModule,
    DynamicDialogModule,
    DialogModule,
    MatIconModule,
    AvatarModule,
    DataViewModule,
    ToastModule,
    MessagesModule,
  ],
  providers: [
    MessageService,
    ToastService,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    environment.useMockHttpInterceptor ?
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MockHttpInterceptor,
        multi: true
      } : [],
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
  ],
  //schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [TablerIconsModule,
    ToastModule,
    MessagesModule,],
  bootstrap: [AppComponent],
})
export class AppModule {

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['en', 'ja']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang?.match(/en|ja/) ? browserLang : 'en');

    window.addEventListener('languagechange', (a) => {
      this.translate.use(navigator.language);
    });
  }

}
